<script>
  import models from './../stores/models';
	import colorsModelsMap from './../stores/colorsModelsMap';
	import SkeletonImage from './SkeletonImage.svelte';
  import SpecImage from './SpecImage.svelte';
  import SpecValue from './SpecValue.svelte';

  export let type = '';
  export let title = '';
  export let showLoader = false;

  const nextCellIsColored = (colorsMap, type, i) => {
    return colorsMap[i] && colorsMap[i][type] && colorsMap[i + 1] && colorsMap[i + 1][type];
  }
</script>

{#each $models as spec, i (spec.id)}
  {#if type === 'img_url'}
    {#if !spec[type]}
      <div class="specs-modal__line-value">
        <SkeletonImage isAnimated={false} />
      </div>
    {:else}
      <div class="specs-modal__line-value">
        <SpecImage src={spec[type]} specId={spec.id} />
      </div>
    {/if}

    {#if showLoader && ($models.length - 1 == i) }
      <SkeletonImage />
    {/if}
  {:else if type === 'title'}
    <span class="specs-modal__line-value specs-modal__title">
      <SpecValue value={spec[type]} {type} {title} />
    </span>
  {:else}
    <span class="
      specs-modal__line-value
      {$colorsModelsMap[i] && $colorsModelsMap[i][type] ? 'specs-modal__line-value_colored' : ''}
      {nextCellIsColored($colorsModelsMap, type, i) ? 'specs-modal__line-value_colored-right-side' : ''}
    ">
      <SpecValue value={spec[type]} {type} {title} />
    </span>
  {/if}
{/each}

<style lang="scss">
  .specs-modal__line-value {
    min-width: 135px;
    max-width: 135px;
    margin-right: 10px;
    text-align: center;
    font-size: 14px;
    padding: 3px 0;

    @media (min-width: 576px) {
      min-width: 220px;
      max-width: 220px;
      margin-right: 30px;
      padding-top: 8px;
      padding-bottom: 8px;
      font-size: 16px;
    }

    @media (min-width: 768px) {
      margin-right: 40px;
    }
  }

  .specs-modal__line-value_colored {
    background: #dedede;

    @media (prefers-color-scheme: dark) {
			background: #404040;
		}
  }

  /* active cell styles if next cell in the same line is active too */
  .specs-modal__line-value_colored-right-side {
    margin-right: 0;
    padding-right: 10px;
    max-width: 145px;
    min-width: 145px;

    @media (min-width: 576px) {
      min-width: 250px;
      max-width: 250px;
      padding-right: 30px;
    }

    @media (min-width: 768px) {
      min-width: 260px;
      max-width: 260px;
      padding-right: 40px;
    }
  }

  .specs-modal__title {
		min-width: 135px;
    max-width: 135px;
		font-weight: 500;
		font-size: 16px;
    text-align: center;

    @media (min-width: 576px) {
      min-width: 220px;
      max-width: 220px;
      font-size: 18px;
      margin-right: 40px;
    }
	}
</style>